// Formatting helpers — P1.15. Pure, Intl.NumberFormat, tabular-nums.
// Allowed for presentation-layer import (pure formatting, no calculation).

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

const usdPreciseFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

const shareFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

/** Whole-dollar USD, e.g. $12,500,000. */
export function usd(x: number): string {
  if (!Number.isFinite(x)) return '—';
  return usdFormatter.format(x);
}

/** Precise USD to 4 decimals, e.g. $2.4125 (per-share values). */
export function usdPrecise(x: number): string {
  if (!Number.isFinite(x)) return '—';
  return usdPreciseFormatter.format(x);
}

/** Percentage from a ratio, e.g. 0.285 -> "28.5%". */
export function pct(x: number, digits = 1): string {
  if (!Number.isFinite(x)) return '—';
  return `${(x * 100).toFixed(digits)}%`;
}

/** Basis-points from a ratio, e.g. 0.0025 -> "25 bps". */
export function pctBps(x: number): string {
  if (!Number.isFinite(x)) return '—';
  return `${Math.round(x * 10000)} bps`;
}

/** ISO date string, pass-through with fallback. */
export function isoDate(iso: string | null): string {
  if (!iso) return '—';
  return iso;
}

/** Share count with grouping, e.g. 10,000,000. */
export function fmtShares(x: number): string {
  if (!Number.isFinite(x)) return '—';
  return shareFormatter.format(x);
}
